
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Usuarios from "../pages/usuarios/page";
import Horarios from "../pages/horarios/page";
import Reservas from "../pages/reservas/page";
import Pagos from "../pages/pagos/page";
import Rutinas from "../pages/rutinas/page";
import Reportes from "../pages/reportes/page";
import Progreso from "../pages/progreso/page";
import Tutoriales from "../pages/tutoriales/page";
import Login from "../pages/login/page";
import Planes from "../pages/planes/page";
import ActivarCuenta from "../pages/activar-cuenta/page";
import Gimnasios from "../pages/gimnasios/page";
import SaasPlanes from "../pages/saas-planes/page";
import PagarServicio from "../pages/pagar-servicio/page";
import PagarServicioReturn from "../pages/pagar-servicio/return";
import ResetPassword from "../pages/reset-password/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/activar-cuenta",
    element: <ActivarCuenta />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/",
    element: <ProtectedRoute><Home /></ProtectedRoute>,
  },
  {
    path: "/usuarios",
    element: <ProtectedRoute><Usuarios /></ProtectedRoute>,
  },
  {
    path: "/planes",
    element: <ProtectedRoute><Planes /></ProtectedRoute>,
  },
  {
    path: "/horarios",
    element: <ProtectedRoute><Horarios /></ProtectedRoute>,
  },
  {
    path: "/reservas",
    element: <ProtectedRoute><Reservas /></ProtectedRoute>,
  },
  {
    path: "/pagos",
    element: <ProtectedRoute><Pagos /></ProtectedRoute>,
  },
  {
    path: "/rutinas",
    element: <ProtectedRoute><Rutinas /></ProtectedRoute>,
  },
  {
    path: "/reportes",
    element: <ProtectedRoute><Reportes /></ProtectedRoute>,
  },
  {
    path: "/progreso",
    element: <ProtectedRoute><Progreso /></ProtectedRoute>,
  },
  {
    path: "/tutoriales",
    element: <ProtectedRoute><Tutoriales /></ProtectedRoute>,
  },
  {
    path: "/gimnasios",
    element: <ProtectedRoute allowedRoles={['platform_admin']}><Gimnasios /></ProtectedRoute>,
  },
  {
    path: "/saas-planes",
    element: <ProtectedRoute allowedRoles={['platform_admin']}><SaasPlanes /></ProtectedRoute>,
  },
  {
    path: "/pagar-servicio",
    element: <ProtectedRoute><PagarServicio /></ProtectedRoute>,
  },
  {
    path: "/pagar-servicio/return",
    element: <ProtectedRoute><PagarServicioReturn /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
